import type { MediaRepository, StoredMedia } from '../../core/ports/media-repository';
export class IndexedDbMediaRepository implements MediaRepository {
  protected store = new Map<string, StoredMedia>();
  async put(asset: StoredMedia): Promise<void> { this.store.set(asset.metadata.assetId, asset); }
  async get(assetId: string): Promise<StoredMedia | null> { return this.store.get(assetId) ?? null; }
  async list(): Promise<StoredMedia[]> { return [...this.store.values()]; }
  async delete(assetId: string): Promise<void> { this.store.delete(assetId); }
  async clear(): Promise<void> { this.store.clear(); }
}
